import axios from 'src/api/Api';
import {
    SEND_USAGE_REPORT_SUCCESS,
    SEND_USAGE_REPORT_FAILURE,
    RESET_SEND_USAGE_REPORT_STATUS,
    SET_NOTIFICATION_FAILURE_RESPONSE,
} from 'src/pages/orders/redux/actions';
import { put,delay } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* retriggerEventNotification(action) {

const params = convertObjectToQueryParams({
        myCaseRef: action.payload.myCaseRef,
        orderType: action.payload?.orderType,
    });
    const flag=action?.flag;
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/retriggerNotification?${params}`;
    try {
        let result = yield axios
            .post(url, action.payload)
            .then((response) => response.data);
        if(flag){
        result.myCaseRef=action.payload.myCaseRef;
        }
        yield put({ type: SET_NOTIFICATION_FAILURE_RESPONSE, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        // In case of error, send failure response with basic error info
        yield put({
            type: SET_NOTIFICATION_FAILURE_RESPONSE,
            data: {
                statusCode: '503',
                statusMessage: errorHandler('503'),
                myCaseRef: action.payload?.myCaseRef,
            },
        });
    }
}
